import { render, staticRenderFns } from "./Procolo18Out.vue?vue&type=template&id=069502b2"
import script from "./Procolo18Out.vue?vue&type=script&lang=js"
export * from "./Procolo18Out.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports